export default __webpack_public_path__ + "static/media/Lip_6_F.f805c7f1.svg";